import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportProjectsVelocity_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportProjectsVelocity extends Report<ReportProjectsVelocity_Settings> {

    static reportName   : string = "Velocity"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_PROJECTS_VELOCITY
        super(data);

        this.icon         = "isvg-velocity"
        // this.description  = "The Velocity Report measures the amount of work completed in each iteration, helping assess how quickly a project is progressing and predict future performance."
        this.description  = "Measures the average amount of work completed over a set period, helping to predict future performance and improve project planning."

        this.settings     = new ReportProjectsVelocity_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportProjectsVelocity {
        return new ReportProjectsVelocity(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportProjectsVelocity_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectIds = [projectId]
    }

    save(){
        console.log("Not implemented")
    }
}
